export interface INews {
  id: string | number
  url: string
  title: string
  pubDate: string | Date
  feedId: string | number
  feedName: string
  feedUrl: string
  feedEnabled: boolean | string
  feedDescription: string
  feedImage: string
  description: string
}

export class News implements INews {
  constructor(
    public id: string | number = '',
    public url: string = '',
    public title: string = '',
    public pubDate: string | Date = '',
    public feedId: string | number = '',
    public feedName: string = '',
    public feedUrl: string = '',
    public feedEnabled: boolean | string = '',
    public feedDescription: string = '',
    public feedImage: string = '',
    public description: string = ''
  ) {}
}

export default News 